import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const useNavigator = () => {
  const history = useHistory();
  const [navigatePath, setNavigatePath] = useState(null);

  const backLength = history?.length;

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!navigatePath) return;

    history.push(navigatePath);
  }, [navigatePath]);

  return { navigate: setNavigatePath, goBack: goBack, backLength: backLength };
};

export default useNavigator;
